import { useContext, useEffect, useState } from 'react'

import Mosaic from '../../assets/images/jaf-institute-mosaic.png'
import { ArrowForward } from '@mui/icons-material'
import DataContext from 'src/contexts/DataContext'
import { navigateToInstitute } from 'src/utils'
import * as S from './styles'
import { useNavigate } from 'react-router-dom'
import { useCourseInfoHook } from 'src/hooks/useCourseInfoHook'

const ConclusionPage = () => {
  const navigate = useNavigate()
  const [courseLogo, setCourseLogo] = useState<string>('')

  const { registration } = useContext(DataContext)

  const currentCourseInfo = useCourseInfoHook({ course: registration.course! })

  useEffect(() => {
    if (!registration.course)
      navigate(`/admissao/${localStorage.getItem('course')}`)
  }, [])

  useEffect(() => {
    currentCourseInfo && setCourseLogo(currentCourseInfo.logo_url)
  }, [currentCourseInfo])

  return (
    <S.ContainerFlex>
      <S.ContainerImage>
        <img src={Mosaic} alt="Mosaico Instituto J&F" />
      </S.ContainerImage>

      <S.Content>
        <S.Title>Candidato(a) inscrito(a) com sucesso!</S.Title>
        <S.RegistrationContainer>
          <div>
            <S.RegistrationLabel>Código de inscrição:</S.RegistrationLabel>

            <S.RegistrationNumber>
              {registration.registration_code}
            </S.RegistrationNumber>
          </div>
          <S.Info>
            Caso não tenha sido possível anexar o documento neste momento, anexe
            na <b>Área do Candidato</b> ou envie para a Equipe de Admissão por
            meio do número de WhatsApp <b>(11)99732-4047</b>.
          </S.Info>
        </S.RegistrationContainer>
        <img src={courseLogo} alt="Logo Germinare" />

        <S.ContainerButton>
          <S.ButtonLargeCuston
            onClick={() => navigate('/candidato')}
            variant={'contained'}
            endIcon={<ArrowForward />}
          >
            Acessar a área do candidato
          </S.ButtonLargeCuston>
          <S.ButtonLargeCuston
            variant={'outlined'}
            endIcon={<ArrowForward />}
            onClick={() => navigateToInstitute()}
          >
            Ir para o site Institucional
          </S.ButtonLargeCuston>
        </S.ContainerButton>
      </S.Content>
    </S.ContainerFlex>
  )
}

export { ConclusionPage }
